import { BuildingBlocksContainer } from 'shared/components/BuildingBlocks';
import { BuildingMainBlockContainer } from 'shared/components/BuildingMainBlock';
import { BuildingMapContainer } from 'shared/components/BuildingMap';
import { BuildingOffersContainer } from 'shared/components/BuildingOffers';
import { BuildingTechContainer } from 'shared/components/BuildingTech';
import { CommercialSubmenuContainer } from 'shared/components/CommercialSubmenu';
import { FloatingHeaderContainer } from 'shared/components/FloatingHeader';
import { SimilarBuildingsContainer } from 'shared/components/SimilarBuildings';

import style from './style.css';

export const BuildingCardPage = () => (
  <div className={style['page']}>
    <CommercialSubmenuContainer />
    <BuildingMainBlockContainer />
    <BuildingOffersContainer />
    <BuildingBlocksContainer />
    <BuildingTechContainer />
    <BuildingMapContainer />
    {/* TODO: «Сообщить об ошибке» (задача 9) — между картой и похожими */}
    <SimilarBuildingsContainer />
    <FloatingHeaderContainer />
  </div>
);
